import {
  BulkEmailConfig,
  BulkEmailTaskDateFilterBy,
  BulkEmailTaskTarget,
  BulkEmailUserStatus,
  BulkEmailUserType,
  FiltersState,
} from '../../interface/interface';

export const framePayload = (filters: FiltersState): any => {
  if (!filters) return undefined;
  const object: BulkEmailConfig = {};

  if (filters?.userType.value === BulkEmailTaskTarget.Patient) {
    if (filters?.userType) object.target = filters?.userType?.value;
    if (filters?.template) object.template = filters?.template?.value;
    if (filters?.status)
      object.active =
        filters?.status?.value === BulkEmailUserType.active ? true : false;
    if (filters?.selectedPatientType)
      object.internal =
        filters?.selectedPatientType?.value === BulkEmailUserStatus.internal
          ? true
          : false;
    if (filters?.isRegistered) {
      object.registered = {
        isPicked: filters?.isRegistered,
        filterBy:
          filters?.registeredFilter?.value !== ''
            ? filters?.registeredFilter?.value
            : undefined,
        startDate: filters?.selectedRegisteredDate
          ? filters?.selectedRegisteredDate
          : undefined,
        endDate: filters?.isRegistered
          ? filters?.registeredFilter?.value ===
            BulkEmailTaskDateFilterBy.Between
            ? filters?.betweenDate
            : undefined
          : undefined,
      };
    }
    if (filters?.isInvited) {
      object.invited = {
        isPicked: filters?.isInvited,
        filterBy:
          filters?.invitedRegisteredFilter?.value !== ''
            ? filters?.invitedRegisteredFilter?.value
            : undefined,
        startDate: filters?.invitedSelectedRegisteredDate
          ? filters?.invitedSelectedRegisteredDate
          : undefined,
        endDate: filters?.isInvited
          ? filters?.invitedRegisteredFilter?.value ===
            BulkEmailTaskDateFilterBy.Between
            ? filters?.invitedBetweenDate
            : undefined
          : undefined,
      };
    }
    object.ignoreIfAlreadySent = filters?.ignoreIfAlreadySent ? true : false;
    return object;
  }

  if (filters?.userType) object.target = filters?.userType?.value;
  if (filters?.template) object.template = filters?.template?.value;
  if (filters?.prescriptionStatus)
    object.prescriptionStatus = filters?.prescriptionStatus?.value;
  if (filters?.product) object.product = filters?.product?.value;
  object.ignoreIfAlreadySent = filters?.ignoreIfAlreadySent ? true : false;

  return object;
};
